// frontend/klaes-app/src/components/FilmFavs/styles/index.js
import cardStyles from '../styleUtils/cards.module.css';
import componentStyles from '../styleUtils/components.module.css';
import layoutStyles from '../styleUtils/layout.module.css';
import modalStyles from '../styleUtils/modals.module.css';
import responsiveStyles from '../styleUtils/responsive.module.css';

export const styles = {
  ...layoutStyles,
  ...cardStyles,
  ...componentStyles,
  ...modalStyles,
  ...responsiveStyles,
};